<template>
    <div class="PmsOrder">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>BBAC专属</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>价格查询</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <div style="display: flex;">
                    <span>注意：价格查询数据仅保留最近30天的查询结果</span>
                    <span style="flex-grow: 1;"></span>
                    <a href="/template/query_price.xlsx" style="margin-right:16px">下载模板</a>
                    <el-button type="primary" @click="() => uploadDialogVisible = true" size="mini">上传待查询数据</el-button>
                    <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">刷新</el-button>
                </div>
                <div ref="tablePosition"></div>
                <el-table
                    :data="tableData"
                    stripe size="mini"
                    v-loading="loading"
                    :height="tableConfig.height"
                    style="width: 100%">
                    <el-table-column
                        prop="createTime"
                        label="查询时间"
                        fixed="left"
                        width="200">
                    </el-table-column>
                    <el-table-column
                        prop="modifiedTime"
                        label="生成结果时间"
                        width="200">
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="状态"
                        align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status == 0">查询中</el-tag>
                            <el-tag v-if="scope.row.status == 1">查询中</el-tag>
                            <el-tag v-if="scope.row.status == 2" type="success">完成</el-tag>
                            <el-tag v-if="scope.row.status == 9" type="danger">失败</el-tag>
                         </template>
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="操作"
                        align="center">
                        <template slot-scope="scope">
                            <el-button type="primary" :disabled="scope.row.status != 2" @click="() => downloadResult(scope.row.id)" size="mini">下载</el-button>
                         </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="prev, pager, next, sizes"
                        v-if="total>0"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @size-change="onSizeChange"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="上传查询数据" :modal="true" :visible.sync="uploadDialogVisible" width="400px">
            <el-upload ref="upload"
                class="upload-demo"
                drag
                action="/api/admin/history/price/task/upload"
                :limit="1"
                accept=".xlsx"
                :on-success="uploadSuccess">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <div v-html="uploadCheckResult"></div>
        </el-dialog>
    </div>
</template>
<script>
import { downloadByPost, convertRes2Blob } from '../../utils/download.js';
const HEIGHT_OFFSET = 118;
export default {

    data() {
        return {
            searchForm: {
            },
            loading: false,
            tableConfig: {
                height: 0,
            },
            total: 0,
            pageSize: 50,
            currentPage: 1,
            tableData: [],
            uploadDialogVisible: false,
        }
    },
    methods: {
        onSearch() {
            const that = this;
            this.loading = true;
            this.$axios.post("/admin/history/price/task/search",{
                cond: "",
                page: this.currentPage - 1,size:this.pageSize,
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    that.tableData = resp.data.content;
                    that.total = resp.data.totalElements;
                }
            }).finally(() => {
                that.loading = false;
            });
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        onSizeChange(val) {
            this.pageSize = val;
            this.onSearch();
        },
        handleDelete() {
            this.uploadDialogVisible = true;
        },
        uploadSuccess(response) {
            const {header: {status, msg}} = response;
            this.$refs.upload.clearFiles();
            if(status === 0) {
                this.$notify({
                    title: '成功',
                    message: '数据保存成功',
                    type: 'success'
                });
                this.uploadDialogVisible = false;
                this.onSearch();
            } else {
                this.uploadCheckResult = msg;
            }
        },
        downloadResult(taskId) {
            downloadByPost({
                axios: this.$axios,
                url: "/admin/history/price/task/download/" + taskId,
                success: response => {
                    convertRes2Blob(response);
                },
            });

        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        }
    },
    created() {
        window.addEventListener("resize", this.setTableHeight);
        this.onSearch();
    },
    mounted() {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            loading.close();
        }, 500);
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    }
}
</script>
<style>
</style>
